export type Deferred<T> = {
    resolve: (v: T | PromiseLike<T>) => void;
    reject: (e: unknown) => void;
    promise: Promise<T>;
};

export function defer<T>(): Deferred<T> {
    let resolve = (_v: T | PromiseLike<T>) => {};
    let reject = (_e: unknown) => {};

    const promise: Promise<T> = new Promise((_resolve, _reject) => {
        resolve = _resolve;
        reject = _reject;
    });

    return {
        resolve,
        reject,
        promise,
    };
}
